import React from 'react';
import { PrivacyPolicyContainer } from './PrivacyStyles.styles';
const SharingPersonalInfo = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Sharing Your Personal Information</h3>
      <p>
        We may share your personal information with third parties to provide and
        improve our services. Specifically, we may share your information in the
        following scenarios:
      </p>
      <ul>
        <li>
          <strong>Payment Processing:</strong> Information will be shared with
          PayPal or other payment processors to facilitate transactions.
        </li>
        <li>
          <strong>Email Communications:</strong> Your email address may be
          shared with email marketing platforms to send newsletters or
          promotional communications (with your consent).
        </li>
        {/* <li>
          <strong>Analytics:</strong> We may share your information with
          analytics providers, such as Google Analytics, to understand how users
          interact with our platform.
        </li> */}
        <li>
          <strong>Legal Obligations:</strong> We may share your information to
          comply with applicable laws, regulations, or legal processes, or to
          protect our rights.
        </li>
        <li>
          <strong>Business Transfers:</strong> In the event of a merger,
          acquisition, or sale of our business, your information may be
          transferred to the new entity.
        </li>
      </ul>
      <p>
        We will never sell your personal information to third parties for
        marketing purposes without your explicit consent.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default SharingPersonalInfo;
